module.exports = __webpack_public_path__ + "static/media/mylesimage.d12e5a96.png";